import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import { lessonsResponseSchema, type Lesson } from './schemas';

// Faz parse do markdown de lessons.md em itens estruturados.
// Convenção do arquivo: `## Section`, depois `### Title` e parágrafo de descrição.
// Itens sem ### viram lições sem section. Linhas em branco e código são ignorados.
function parseLessonsMarkdown(md: string): Lesson[] {
  const lines = md.split('\n');
  const items: Lesson[] = [];
  let currentSection: string | null = null;
  let currentTitle: string | null = null;
  let currentBuffer: string[] = [];
  let inCode = false;
  let counter = 0;

  function flush() {
    if (!currentTitle) return;
    const id = `l-${++counter}`;
    items.push({
      id,
      section: currentSection,
      date: null,
      title: currentTitle,
      description: currentBuffer.join('\n').trim(),
    });
    currentTitle = null;
    currentBuffer = [];
  }

  for (const raw of lines) {
    if (raw.trim().startsWith('```')) {
      inCode = !inCode;
      continue;
    }
    if (inCode) continue;

    const h2 = raw.match(/^##\s+(.+)/);
    const h3 = raw.match(/^###\s+(.+)/);

    if (h2 && h2[1] !== undefined) {
      flush();
      currentSection = h2[1].trim();
      continue;
    }
    if (h3 && h3[1] !== undefined) {
      flush();
      currentTitle = h3[1].trim();
      continue;
    }
    if (currentTitle) {
      currentBuffer.push(raw);
    }
  }
  flush();
  return items;
}

export function useLessons() {
  return useQuery({
    queryKey: ['history', 'lessons'] as const,
    queryFn: ({ signal }) =>
      api('/api/lessons', { schema: lessonsResponseSchema, signal }),
    select: (data): Lesson[] => parseLessonsMarkdown(data.content),
    staleTime: 5 * 60_000,
  });
}
